export enum LocalStorageKey {
	AuthToken = 'authToken',
	Api = 'api',
	LastUsedOrg = 'lastUsedOrg'
}
